import React, { useEffect, useRef } from 'react';
import loadScript from 'lib/loadScript';
import htmlSetIframeLoadingAttributes from 'lib/htmlSetIframeLoadingAttributes';

/**
 * Pinterest widget component.
 *
 * @param {object} props - Component props.
 * @param {import('../../../../lib/graphqlTypeDefs.mjs').Widget} props.widget - Widget data containing baseline HTML.
 * @returns {JSX.Element} The Pinterest widget.
 */
export const Pinterest = ({ widget }) => {
  const embedRef = useRef(null);

  useEffect(() => {
    loadScript(
      '//assets.pinterest.com/js/pinit.js',
      {
        attributes: {
          defer: true,
          'data-pin-build': 'parsePinBtns', // expose internal pinterest build function
        },
      },
    )
      // re-running `.process` here since in SPA mode, the script needs to re-parse
      // embeds on the page when navigating to a new article
      .then(() => window.parsePinBtns && window.parsePinBtns(embedRef.current));
  }, []);

  // Strip script tags from content.
  const baseline = htmlSetIframeLoadingAttributes(
    widget.baseline.replace(
      /<script[^<]+src="([^"]+)"[^<]*><\/script>/gi,
      '',
    ),
    'lazy',
  );

  /* eslint-disable react/no-danger */
  return (
    <div
      ref={embedRef}
      data-testid="pinterest-embed"
      dangerouslySetInnerHTML={{ __html: baseline }}
    />
  );
};

